// Simple singleton tooltip manager that mounts a single tooltip element to document.body
const TOOLTIP_ID = 'results-v2-body-tooltip';
let tooltipEl = null;
let rafId = null;
let hideTimeout = null;
let pending = null;
let listenersAdded = false;

function ensureEl() {
  if (typeof document === 'undefined') return null;
  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    ensureGlobalListeners();
    tooltipEl.id = TOOLTIP_ID;
    // apply robust inline styles; use setProperty for z-index to override stylesheet specificity
    tooltipEl.style.position = 'fixed';
    tooltipEl.style.display = 'none';
    tooltipEl.style.background = 'white';
    tooltipEl.style.padding = '6px 8px';
    tooltipEl.style.borderRadius = '4px';
    tooltipEl.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
    tooltipEl.style.fontSize = '13px';
    tooltipEl.style.pointerEvents = 'none';
    tooltipEl.style.opacity = '0';
    tooltipEl.style.transition = 'none';
    tooltipEl.style.whiteSpace = 'nowrap';
    tooltipEl.style.setProperty('z-index', '2147483647', 'important');
    tooltipEl.style.setProperty('left', '0px', 'important');
    tooltipEl.style.setProperty('top', '0px', 'important');
    tooltipEl.setAttribute('role', 'tooltip');
    document.body.appendChild(tooltipEl);
  }
  return tooltipEl;
}

function ensureGlobalListeners() {
  if (listenersAdded || typeof window === 'undefined') return;
  const hideNow = () => {
    try { hideTooltip(0); } catch(e){}
  };
  // Hide on wheel/scroll-ish interactions, touch, resize, blur, or visibility change
  const opts = { passive: true };
  try {
    //window.addEventListener('wheel', hideNow, opts);
    window.addEventListener('resize', hideNow, opts);
    window.addEventListener('blur', hideNow, opts);
    window.addEventListener('scroll', hideNow, { passive: true, capture: true });
    document.addEventListener('visibilitychange', hideNow, opts);
    document.addEventListener('touchstart', hideNow, opts);
    document.addEventListener('touchmove', hideNow, opts);
    document.addEventListener('keydown', hideNow, opts);
  } catch (e) { /* ignore */ }
  listenersAdded = true;
}

function applyPending() {
  rafId = null;
  if (!pending) return;
  const el = ensureEl();
  if (!el) return;
  const { html, x, y } = pending;
  try {
    el.innerHTML = html || '';
    el.style.setProperty('left', (x) + 'px', 'important');
    el.style.setProperty('top', Math.max(8, (y - 8)) + 'px', 'important');
    el.style.display = 'block';
    el.style.opacity = '1';
  } catch (e) {
    // ignore DOM exceptions
  }
  pending = null;
}

export function showTooltip({ html, x = 0, y = 0 }) {
  if (hideTimeout) { clearTimeout(hideTimeout); hideTimeout = null; }
  pending = { html, x, y };
  ensureGlobalListeners();
  if (!rafId) rafId = window.requestAnimationFrame(applyPending);
}

export function hideTooltip(delay = 0) {
  if (hideTimeout) clearTimeout(hideTimeout);
  hideTimeout = window.setTimeout(() => {
    if (rafId) { window.cancelAnimationFrame(rafId); rafId = null; }
    const el = ensureEl();
    if (el) { el.style.opacity = '0'; el.style.display = 'none'; }
    pending = null;
    hideTimeout = null;
  }, delay);
}

export function moveTooltip(x = 0, y = 0) {
  try {
    const el = ensureEl();
    if (!el) return;
    if (el.style.display === 'none') return;
    el.style.setProperty('left', (x) + 'px', 'important');
    el.style.setProperty('top', Math.max(8, (y - 8)) + 'px', 'important');
  } catch (e) { /* ignore */ }
}

export function destroyTooltip() {
  if (hideTimeout) clearTimeout(hideTimeout);
  if (rafId) { window.cancelAnimationFrame(rafId); rafId = null; }
  if (tooltipEl && tooltipEl.parentNode) tooltipEl.parentNode.removeChild(tooltipEl);
  tooltipEl = null;
}

export default { showTooltip, hideTooltip, moveTooltip, destroyTooltip };
